import {createRouter, createWebHistory, RouterView} from 'vue-router';
import settingsRoutes from '@/modules/settings/router';
import tenantsRoutes from '@/modules/tenants/router';
import accountsRoutes from '@/modules/accounts/router';
import messagingRoutes from '@/modules/messaging/router';
import oidcApplicationsRoutes from '@/modules/oidc-applications/router';
import logsRoutes from '@/modules/logs/router';
import {useCurrentUserStore} from "@/stores/current-user";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            component: RouterView,
            beforeEnter: async () => {
                const {getCurrentUser} = useCurrentUserStore();
                await getCurrentUser();
            },
            meta: {
                auth: true,
                breadcrumb: 'Home'
            },
            redirect: {
                name: 'dashboard'
            },
            children: [
                {
                    path: 'administration',
                    name: 'administration',
                    component: () => import('@/views/AdministrationView.vue'),
                    meta: {
                        breadcrumb: 'Administration'
                    },
                    redirect: {
                        name: 'administration.dashboard'
                    },
                    children: [
                        {
                            path: 'dashboard',
                            name: 'administration.dashboard',
                            component: () => import('@/views/AdminDashboardView.vue'),
                            meta: {
                                breadcrumb: 'Dashboard'
                            }
                        },
                        ...tenantsRoutes,
                        ...accountsRoutes,
                        ...messagingRoutes,
                        ...oidcApplicationsRoutes,
                        ...logsRoutes,
                    ]
                },
                ...settingsRoutes,
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: () => import('@/views/DashboardView.vue')
                }
            ]
        },
        {
            path: '/endsession',
            redirect: {path: '/'}
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: {path: '/'},
        }
    ]
})


export default router
